<!--
 * @Author:
 * @LastEditTime: 2023-07-28
 * @Description: 风险点清单
-->
<template>
  <el-card class="h-full">
    <el-tabs v-model="activeName" class="h-full">
      <el-tab-pane label="设备设施清单" name="equipmentList" class="h-full">
        <equip-table v-if="activeName === 'equipmentList'" class="h-full"></equip-table>
      </el-tab-pane>
      <el-tab-pane label="作业活动清单" name="jobList" class="h-full">
        <job-table v-if="activeName === 'jobList'" class="h-full"></job-table>
      </el-tab-pane>
    </el-tabs>
  </el-card>
</template>

<script>
import EquipTable from '../components/RiskPointTable/EquipTable'
import JobTable from '../components/RiskPointTable/JobTable'

export default {
  name: 'risk-point-list',
  components: {
    EquipTable,
    JobTable,
  },
  data() {
    return {
      activeName: 'equipmentList',
    }
  },
}
</script>

<style scoped lang="scss">
::v-deep .el-card__body {
  height: 100%;
}
::v-deep .el-tabs {
  height: 100%;
}
::v-deep .el-tabs__content {
  height: calc(100% - 54px) !important;
  position: inherit;
  .el-tab-pane {
    height: 100%;
  }
}
</style>
